import { cn } from "cn";

export interface CollectionRefreshBarProps {
    isRefreshing: boolean;
    className?: string;
}

export function CollectionRefreshBar({ isRefreshing, className }: CollectionRefreshBarProps) {
    return (
        <div aria-hidden="true" className={cn("bg-primary/15 pointer-events-none absolute inset-x-0 top-0 z-10 h-0.5 overflow-hidden rounded-full transition-opacity duration-200", isRefreshing ? "opacity-100" : "opacity-0", className)}>
            {/* intent-ui-deviation: hand-rolled 2px bar instead of the vendored `progress-bar` — this is a
                decorative, aria-hidden loading cue; React Aria's ProgressBar injects role=progressbar +
                aria-valuetext status semantics we deliberately keep OFF the bar and route through the
                collection's separate `refreshedAnnouncement` polite region instead. */}
            <div className="animate-collection-refresh-bar bg-primary h-full w-2/5 rounded-full motion-reduce:w-full motion-reduce:animate-none" />
        </div>
    );
}
